import { render } from "./TrashItem.vue?vue&type=template&id=d74b7a70"
import script from "./TrashItem.vue?vue&type=script&lang=js"
export * from "./TrashItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__